import { IAccessRightProfile } from "fieldpro-tools";
import _ from "lodash";

export const getMobileProfileFilterOptions = (
  accessRightProfiles?: IAccessRightProfile[],
) => {
  const validMobileProfiles = _.filter(
    accessRightProfiles,
    (accessRightProfile: IAccessRightProfile) =>
      accessRightProfile.actions["FETCH_DASHBOARD"] === true,
    // the shape of this object has changed because of this refactor https://optimetriks.atlassian.net/browse/FP-9224
    // && !!accessRightProfile.action_details?.["FETCH_DASHBOARD"],
  );

  return _.map(validMobileProfiles, ({ name }) => ({
    key: name,
    label: name,
  }));
};
